var map = {
  "./km.json": [
    "436961",
    "388340"
  ],
  "./ru.json": [
    "749255",
    "962371"
  ],
  "./bg.json": [
    "714106",
    "431019"
  ],
  "./el.json": [
    "268916",
    "868403"
  ],
  "./en-pt.json": [
    "605406",
    "177973"
  ],
  "./ja.json": [
    "353092",
    "211901"
  ],
  "./ar.json": [
    "955282",
    "457396"
  ],
  "./rw.json": [
    "878304",
    "342994"
  ],
  "./sr.json": [
    "792868",
    "48883"
  ],
  "./lol.json": [
    "733266",
    "56841"
  ],
  "./fr.json": [
    "196387",
    "541666"
  ],
  "./sv.json": [
    "305023",
    "838785"
  ],
  "./as.json": [
    "264955",
    "129562"
  ],
  "./gu.json": [
    "892730",
    "954503"
  ],
  "./kk.json": [
    "424617",
    "274063"
  ],
  "./nb.json": [
    "692462",
    "625484"
  ],
  "./ta.json": [
    "77026",
    "207746"
  ],
  "./ky.json": [
    "638001",
    "158521"
  ],
  "./pl.json": [
    "865963",
    "241489"
  ],
  "./ro.json": [
    "151561",
    "419652"
  ],
  "./ka.json": [
    "920672",
    "778815"
  ],
  "./hu.json": [
    "517629",
    "574456"
  ],
  "./uk.json": [
    "102790",
    "959844"
  ],
  "./or.json": [
    "720689",
    "84069"
  ],
  "./uz.json": [
    "968587",
    "100204"
  ],
  "./hy.json": [
    "108509",
    "206815"
  ],
  "./de.json": [
    "504557",
    "146739"
  ],
  "./pt-pt.json": [
    "581654",
    "391433"
  ],
  "./vi.json": [
    "552880",
    "50408"
  ],
  "./tr.json": [
    "639729",
    "415923"
  ],
  "./da.json": [
    "668712",
    "613600"
  ],
  "./kn.json": [
    "557629",
    "819468"
  ],
  "./mr.json": [
    "754765",
    "420197"
  ],
  "./id.json": [
    "609962",
    "209789"
  ],
  "./lt.json": [
    "262310",
    "97883"
  ],
  "./lv.json": [
    "365256",
    "646662"
  ],
  "./fv.json": [
    "147192",
    "113533"
  ],
  "./zh-hans.json": [
    "218048",
    "720964"
  ],
  "./es.json": [
    "345834",
    "765792"
  ],
  "./ko.json": [
    "707826",
    "80152"
  ],
  "./bn.json": [
    "670596",
    "177159"
  ],
  "./cs.json": [
    "707162",
    "440312"
  ],
  "./boxes.json": [
    "115205",
    "583030"
  ],
  "./my.json": [
    "733773",
    "129773"
  ],
  "./mn.json": [
    "360594",
    "616594"
  ],
  "./sk.json": [
    "535820",
    "158052"
  ],
  "./nl.json": [
    "694636",
    "450126"
  ],
  "./az.json": [
    "238607",
    "754477"
  ],
  "./accents.json": [
    "316945",
    "886655"
  ],
  "./pa.json": [
    "561125",
    "170891"
  ],
  "./pt.json": [
    "87106",
    "791295"
  ],
  "./extra.json": [
    "189470",
    "929230"
  ],
  "./it.json": [
    "66013",
    "834162"
  ],
  "./hi.json": [
    "761181",
    "964007"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 944078;
module.exports = webpackAsyncContext;
